import yup from 'utils/yup';

export const initialWebhooksData = {
  url: '',
  signature_secret_key: '',
  active: true,
  events: [] as any,
};

export const webhookFormValidationSchema = yup.object().shape({
  url: yup.string().url().required(),
  signature_secret_key: yup.string().required(),
  events: yup.string().required(),
});
